import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'

export default createUseStyles({
  warningText: {
    ...typography['Lato Body 1'],
    textAlign: 'center',
    marginTop: 24,
    [forPhoneOnly]: {
      marginTop: 24,
    },
  },
  icon: {
    width: 64,
    height: 64,
  },
})
